export var CanisterType;
(function (CanisterType) {
    CanisterType["nft"] = "nft";
    CanisterType["ic_punks"] = "ic_punks";
    CanisterType["starverse"] = "starverse";
    CanisterType["cronic"] = "cronic";
})(CanisterType || (CanisterType = {}));
//# sourceMappingURL=NFTCanister.js.map